import React from "react";
import styled from "styled-components";

const MetricCardColors = {
    "Total Intraverse Users": "#3E227B",
    "Total Logins": "#005967",
    "Unique Logins": "#741965",
    "Average Session": "#00359F",
    "Completed 5+ Rooms": "#3C114C",
};

const IncreaseRateColors = {
    "Total Intraverse Users": "#BBA9DB", // soft lavender (lighter of #3E227B)
    "Total Logins": "#66A9B0", // light teal
    "Unique Logins": "#D08FBA", // light magenta/rose
    "Average Session": "#7C9DED", // muted cornflower
    "Completed 5+ Rooms": "#C07DB5", // soft plum/rose
};

const MetricCard = ({ cardValue, cardType, increaseRate }) => (
    <Card cardType={cardType}>
        <CardContent>
            <IncreaseRateContainer cardType={cardType}>{increaseRate}</IncreaseRateContainer>

            <CardText>
                {cardValue}
                {cardType === "Average Session" && (
                    <>
                        {" "}
                        <CardText as="span" fontSize="22px" fontWeight="500">
                            mins
                        </CardText>
                    </>
                )}
            </CardText>
            <CardTitle>{cardType}</CardTitle>
        </CardContent>
    </Card>
);

export default MetricCard;

const Card = styled.div`
    display: flex;
    padding: 24px 40px 30px 40px;
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
    flex: 1 0 0;
    border-radius: 14px;
    background: ${({ cardType }) => MetricCardColors[cardType] || "rgba(251, 252, 255, 0.10)"};

    @media (max-width: 768px) {
        width: 100%;
    }
`;

const CardContent = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 6px;
    align-self: stretch;
`;

const IncreaseRateContainer = styled.div`
    display: flex;
    padding: 4px 10px;
    justify-content: center;
    align-items: center;
    gap: 4px;
    border-radius: 30px;
    align-self: flex-end;
    background: ${({ cardType }) => IncreaseRateColors[cardType] || "rgba(251, 252, 255, 0.70)"};
`;

const CardText = styled.p`
    color: var(--Text-Primary, #fbfcff);
    font-family: "Barlow";
    font-size: ${(props) => props.fontSize || "26px"};
    font-style: normal;
    font-weight: ${(props) => props.fontWeight || "700"};
    line-height: normal;
`;

const CardTitle = styled.p`
    color: var(--White---Black-Secondary, #ced1d9);
    font-family: "Barlow";
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    text-transform: capitalize;
    letter-spacing: 0px;
`;
